import React, {useEffect, useState} from 'react'
import './CustomTreeview.scss'
import 'react-checkbox-tree/lib/react-checkbox-tree.css';
import CheckboxTree from 'react-checkbox-tree';

interface IProps {
  nodes?: any,
  showNodeIcon?:any,
  checked?:any,
  onCheck?:any,
  showExpandAll?:any,
  expandNode?:any,
  noCascade?:any,
  'data-attribute'?: any,
}

const CustomTreeview = ({nodes, showNodeIcon,checked, onCheck,showExpandAll,expandNode,noCascade, 'data-attribute': dataAttribute}:IProps) => {
const[expanded, setExpanded] = useState<any>([])
useEffect(()=> {
  setExpanded(expandNode)
},[expandNode])
  return (
    <CheckboxTree
      nodes={nodes}
      checked={checked}
      onCheck={onCheck}
      expanded={expanded}
      onExpand={expand =>setExpanded(expand)}
      showNodeIcon={showNodeIcon}
      showExpandAll={showExpandAll}
      noCascade={noCascade}
      data-attribute={dataAttribute}
    />
  )
}

export default CustomTreeview
